import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { OpportunityCategory } from "./";

const createCustomFilter = createCustomFilterForEntity<OpportunityCategory>();

export class OpportunityCategoryFilters {
  /**
   * # 🌟✨ HyperFilter – The Ultimate Filtering Powerhouse!
   * ### 🤝 Filter through complex relations effortlessly
   * ### 📦 Directly filter JSON fields (no backend work required!)
   * ### 🚀 Transforms your filter into a single, optimized DB query
   * ### 🔒 Engineered for maximum SQL injection protection
   *
   * ---
   * ### Example:
   * ```ts
   * myEntityRepo.find({
   *  where: MyEntity.hyperFilter({ ... })
   * })
   * ```
   *
   * ---
   * Built by Natan Salmon
   */
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<OpportunityCategory>
  >((filters) => {
    return filterWithRelationsAndJson(OpportunityCategory)(filters);
  });
}








